import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Renewal_alert = () => {
  useAuthRedirect();
  const [vehicles, setVehicles] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Periodic Entry Renewal Alert", "view");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/renewal_alert?branch_code=${selectedBranch}`
        );
        const { vehicles, maintenance } = response.data;

          // Merge maintenance details with vehicle data
          const mergedData = vehicles.map((vehicle) => {
            const maintenanceDetails = maintenance.find(m => m.vehicle_code === vehicle.vehicle_code) || {};
            return {
              ...vehicle,
              fld_des: maintenanceDetails.fld_des || "N/A",
              last_modified_hr: maintenanceDetails.last_modified_hr || "N/A",
              changing_hrs: maintenanceDetails.changing_hrs || "N/A",
              tot1: maintenanceDetails.tot1 || 0,
              tot2: maintenanceDetails.tot2 || 0,
            };
          });

          setVehicles(mergedData);
          setFilteredData(mergedData);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = vehicles.filter((item) => {
      return (
        (item.vehicle_code && item.vehicle_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_name && item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_number && item.vehicle_number.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1);
  };

     if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Periodic Entry Renewal Alert</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Description</th>
                <th>Last Changed Hr/Km</th>
                <th>Next Service Cumulative Hr/Km</th>
                <th>Current Cum Hr/Km</th>
                <th>Remaining Hr/Km</th>
                <th>Alerts</th>
              </tr>
            </thead>

            <tbody>
  {loading ? (
    <tr>
      <td colSpan="8" className="loading-text">
        Loading data, please wait...
      </td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => {
      const total = (parseFloat(item.last_modified_hr) || 0) + (parseFloat(item.changing_hrs) || 0);

      const now_km = item.vehicle_basis === "Hour"
        ? total - (parseFloat(item.tot1) || 0)
        : total - (parseFloat(item.tot2) || 0);

      return (
        <tr key={index}>
          <td>{indexOfFirstItem + index + 1}</td>
          <td>{item.vehicle_code}</td>
          <td>{item.fld_des}</td>
          <td>{item.last_modified_hr}</td>
          <td>{item.changing_hrs}</td>
          <td>{total}</td>
          <td>{now_km}</td>
          <td>
            {now_km < 0 ? (
              <span style={{color: 'red', fontWeight: 'bold'}}>Service Due</span>
            ) : (
              <span style={{color: 'green', fontWeight: 'bold'}}>OK</span>
            )}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="8">No Data Available</td>
    </tr>
  )}
</tbody>

           

          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Renewal_alert;
